import { hdrm } from '@yola/ws-sdk';
import helpers from '../helpers';

const isGdprCheckboxEnabled = (elementId) => {
  const gdprQuerySelector = helpers.getGdprCheckboxQuerySelector();
  return hdrm.verifiers.areChildrenEnabled(elementId, gdprQuerySelector);
};
export default isGdprCheckboxEnabled;
